export default __webpack_public_path__ + "99a4fd4b288d2530ae56284bc618d4d3.png";